import ApplicationController from "./application_controller";
import Rails from "@rails/ujs";
/* This is the custom StimulusReflex controller for the Conge Reflex.
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends ApplicationController {
    /*
     * Regular Stimulus lifecycle methods
     * Learn more at: https://stimulusjs.org/reference/lifecycle-callbacks
     *
     * If you intend to use this controller as a regular stimulus controller as well,
     * make sure any Stimulus lifecycle methods overridden in ApplicationController call super.
     *
     * Important:
     * By default, StimulusReflex overrides the -connect- method so make sure you
     * call super if you intend to do anything else when this controller connects.
     */
    static targets = ["hm0_output"];

    connect() {
        console.log("Factures_Client JS en cours ...");
        super.connect();
        // add your code here, if applicable


        if (
            $("#partial-reglements-content").length &&
            $("#partial-reglements-content").text().search(/Chargement en cours/i) > -1
        ) {
            //on est sur le show
            setTimeout(() => this.reglements_hm_ajax(), 300);
        }

        if (
            $("#partial-interventions-content").length &&
            $("#partial-interventions-content").text().search(/Chargement en cours/i) > -1
        ) {
            //on est sur le show
            setTimeout(() => this.interventions_hm_ajax(), 300);
        }

        if (
            $("#partial-avoirs_sur_facture-content").length &&
            $("#partial-avoirs_sur_facture-content").text().search(/Chargement en cours/i) > -1
        ) {
            //on est sur le show
            setTimeout(() => this.avoirs_sur_facture_hm_ajax(), 300);
        }

        if (
            $("#partial-relances-content").length &&
            $("#partial-relances-content").text().search(/Chargement en cours/i) > -1
        ) {
            //on est sur le show
            setTimeout(() => this.relances_hm_ajax(), 300);
        }

        if (
            $("#partial-documents2-content").length &&
            $("#partial-documents2-content").text().search(/Chargement en cours/i) > -1
        ) {
            //on est sur le show
            setTimeout(() => this.documents2_hm_ajax(), 300);
        }


        if ($("#search").length && $("#quick_sort").length) {

            //on est sur la vue list
            this.rerender();
            (function ($) {
                $.each(["show", "hide"], function (i, ev) {
                    var el = $.fn[ev];
                    $.fn[ev] = function () {
                        this.trigger(ev);
                        return el.apply(this, arguments);
                    };
                });
            })(jQuery);
            $("#spinner").on("show", function () {
                $("#total_entries").hide();
            });
            $("#spinner").on("hide", function () {
                $("#total_entries").show();
            });
            $("#filterrific_with_entreprise_raison_sociale").on("input", function () {
                $("#target_entreprise_raison_sociale").val(
                    $("#filterrific_with_entreprise_raison_sociale").val()
                );
            });
            var targetElement = document.getElementById("mySidebar");
            targetElement.addEventListener("scroll", (event) => {
                var element = document.getElementById("mySidebar");
                console.log("From factures_client_controller.js =======> ", element.scrollTop);
                document.getElementById("scrollevel").value = element.scrollTop;
            });

            this.handleSidebarScroll("factures_client_");
        }

    }

    reglements_hm_ajax() {
        if (this.current_app && this.factures_client_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/factures_clients/show_ajax_for_hm_reglements?factures_client_id=" +
                this.factures_client_id +
                "&vr2=1";
            console.log(url);
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-reglements-content").html("");
                    $("#partial-reglements-content").html(text);
                })
            );
        }
    }
    interventions_hm_ajax() {
        if (this.current_app && this.factures_client_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/factures_clients/show_ajax_for_hm_interventions?factures_client_id=" +
                this.factures_client_id +
                "&vr2=1";
            console.log(url);
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-interventions-content").html("");
                    $("#partial-interventions-content").html(text);
                })
            );
        }
    }

    avoirs_sur_facture_hm_ajax() {
        if (this.current_app && this.factures_client_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/factures_clients/show_ajax_for_hm_avoirs_sur_facture?factures_client_id=" +
                this.factures_client_id +
                "&vr2=1";
            console.log(url);
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-avoirs_sur_facture-content").html("");
                    $("#partial-avoirs_sur_facture-content").html(text);
                })
            );
        }
    }

    relances_hm_ajax() {
        if (this.current_app && this.factures_client_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/factures_clients/show_ajax_for_hm_relances?factures_client_id=" +
                this.factures_client_id +
                "&vr2=1";
            console.log(url);
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-relances-content").html("");
                    $("#partial-relances-content").html(text);
                })
            );
        }
    }

    documents2_hm_ajax() {
        if (this.current_app && this.factures_client_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/factures_clients/show_ajax_for_hm_documents2?factures_client_id=" +
                this.factures_client_id +
                "&vr2=1";
            console.log(url);
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-documents2-content").html("");
                    $("#partial-documents2-content").html(text);
                })
            );
        }
    }

    refreshFlowStatus(event) {
        event.preventDefault();
        event.stopPropagation();
        if (!this.current_app || !this.factures_client_id) return;

        const btn = event.currentTarget;
        const icon = btn.querySelector("i");
        if (icon) icon.classList.add("fa-spin");
        btn.disabled = true;

        const url =
            window.location.origin +
            "/" +
            this.current_app +
            "/factures_clients/get_flow_status?factures_client_id=" +
            this.factures_client_id;

        fetch(url)
            .then((response) => response.text())
            .then((text) => {
                $("#partial-facture-fe-history-content").html(text);
            })
            .catch(() => {
                $("#partial-facture-fe-history-content").html(
                    '<div class="facture-show-refresh-message facture-show-refresh-error"><i class="fas fa-exclamation-circle"></i>Erreur lors du rafraîchissement.</div>'
                );
            })
            .finally(() => {
                if (icon) icon.classList.remove("fa-spin");
                btn.disabled = false;
            });
    }
    update_hmfs() {
        var table = document.getElementById("hmf_prestations");
        // Check if the table element exists
        if (table) {
            // Get all input elements with id "_prix" inside the table
            var inputElements = table.querySelectorAll("input[id*='_prix']");

            // Loop through the input elements and do something
            for (var i = 0; i < inputElements.length; i++) {
                var inputElement = inputElements[i];
                // Do something with the input element, for example, log its value
                if (parseFloat(inputElement.value) > 0) {
                    inputElement.dispatchEvent(new Event("change"));
                }
            }
        }
    }
    lock_unlock_filter_type_reglement_ent(event) {
        console.log(event);
        var selectElement = event.target;
        var selectedValues = [];
        var elementToHide = document.getElementById(
            "filterrific_with_type_de_reglement_ent_multi"
        );
        for (var i = 0; i < selectElement.options.length; i++) {
            if (selectElement.options[i].selected) {
                selectedValues.push(selectElement.options[i].value);
            }
        }
        selectedValues = selectedValues.filter(value => value !== "" && value !== "-1");
        elementToHide.disabled = selectedValues.length != 1;
    }
    get current_app() {
        return this.data.get("app");
    }

    get params() {
        return this.data.get("params");
    }

    get factures_client_id() {
        return this.data.get("factures_clientid");
    }

    get url_solution() {
        return this.data.get("urlsolution");
    }
}
